/**
 * Color tokens, matching the untool-mage palette so the two internal staff
 * tools read as one family.
 */

// Brand — blue (primary)
export const blue = {
  main: '#0071FF',
  light: '#338DFF',
  dark: '#0056CC',
  contrastText: '#FFFFFF'
} as const

// Brand — green (secondary)
export const green = {
  main: '#22C55E',
  light: '#4ade80',
  dark: '#16a34a',
  contrastText: '#FFFFFF'
} as const

export const semantic = {
  success: {
    main: '#22C55E',
    light: '#4ade80',
    dark: '#16a34a'
  },
  error: {
    main: '#DC2626',
    light: '#FEF6F6',
    dark: '#4A1515'
  },
  warning: {
    main: '#EE8437',
    light: '#FEFAF7',
    dark: '#3D2410'
  },
  info: {
    main: '#0071FF',
    light: '#F5F9FF',
    dark: '#0A1929'
  }
} as const

export const lightMode = {
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF'
  },
  text: {
    primary: '#111827',
    secondary: '#4B5563'
  },
  divider: '#E5E7EB'
} as const

export const darkMode = {
  background: {
    default: '#303643',
    paper: '#3A4258'
  },
  text: {
    primary: '#E8EAED',
    secondary: '#BCC3D0'
  },
  divider: '#4A5061'
} as const
